module.exports = __webpack_public_path__ + "media/home.022aa8ed.mp4";